import axios, { type AxiosRequestConfig } from "axios";
import { BaseResponse } from "@/api/api";
import { useMainStore } from "@/store";
import { getClientId } from "@/utils/auth-guard";

/** 默认 HTTP 超时（毫秒） */
export const REQUEST_TIMEOUT_MS = 20_000;
/** 列表类接口：展开行并发拉大数据时易排队，适当放宽 */
export const REQUEST_TIMEOUT_LIST_MS = 45_000;
/** 大 payload 接口（如 arb stat 开平仓全量） */
export const REQUEST_TIMEOUT_HEAVY_MS = 120_000;

//创建一个axios实例
export const $request = axios.create({
  //配置请求根路径
  baseURL: "/sapi",
  //请求的超时时间
  timeout: REQUEST_TIMEOUT_MS,
});

$request.interceptors.request.use((config) => {
  config.headers = config.headers ?? {};
  config.headers["X-TX-Client-Id"] = getClientId();
  return config;
});

export const $get = async (url: string, params: any) => {
  const { data } = await $request.get(url, { params: params });
  return data;
};
export const $getWithAuth = async (
  url: string,
  params: any,
  config?: AxiosRequestConfig
) => {
  const auth = useMainStore().token;
  if (auth == undefined) {
    return {
      msg: "Permission denied",
    };
  }
  const { data } = await $request.get(url, {
    params: params,
    headers: { "Content-Type": "application/json", Authorization: auth },
    ...config,
  });
  return data;
};

//封装一个post
export const $post = async (url: string, params: any) => {
  const { data } = await $request.post(url, params, {
    headers: { "Content-Type": "application/json" },
  });
  return data;
};

export const $postWithAuth = async (url: string, params: any) => {
  const auth = useMainStore().token;
  if (auth == undefined) {
    return {
      msg: "Permission denied",
    };
  }
  const { data } = await $request.post(url, params, {
    headers: { "Content-Type": "application/json", Authorization: auth },
  });
  return data;
};
